// extracted by mini-css-extract-plugin
export default {"_":"EditPanel____3TSg5","_hr":"EditPanel__hr__s+uFL"};